export type TierType = 'A' | 'B' | 'C' | 'D';
export type TrendDirection = 'up' | 'down' | 'flat';

export interface TierSummary {
  tier: TierType;
  stores: number;
  revenuePerWeek: string;
  description: string;
}

export interface StoreItem {
  id: string;
  storeName: string;
  city: string;
  tier: TierType;
  weeklyRevenue: number;
  target: number | null;
  trendPercent: number;
  trendDirection: TrendDirection;
  margin: number;
  frequency: string;
  lastOrder: string;
  lastOrderDays: number;
  fullAddress: string;
  zipCode: string;
  route: string;
  activeDays: string;
  owner: string;
  phone: string;
  email: string;
  salesRep: string;
  ordersPerWeek: number;
  aov: number;
  tierMonths: number;
  recommendedActions: string[];
}

export const ITEMS_PER_PAGE = 10;

/**
 * Maps a customer's pricing tier name to the four-tier UI bucket.
 * Until per-tier classification is wired, all customers default to 'C'.
 */
export function tierFromPricing(name: string | null | undefined): TierType {
  if (!name) return 'C';
  const lower = name.toLowerCase();
  if (lower.includes('gold') || lower.includes('a')) return 'A';
  if (lower.includes('silver') || lower.includes('b')) return 'B';
  if (lower.includes('bronze') || lower.includes('c')) return 'C';
  return 'D';
}
